// src/awsConfig.js
import { CognitoUserPool } from "amazon-cognito-identity-js";

// NOTE: cloned from x20-creative's Cognito pool so the login/logout flow works
// out of the box for the shell. Swap these for an x20-founder-specific User Pool
// once one is provisioned in AWS Cognito.
const poolData = {
  UserPoolId: "us-east-1_EHLNaw2f5",
  ClientId: "2qlo02casnk0gthkjem39uvlfj",
};

// Export the configured Cognito User Pool
export const userPool = new CognitoUserPool(poolData);
